export const lang = state => state.lang;

export const languages = () => [
	{ code: 'en-GB', name: 'English UK' },
	{ code: 'en-US', name: 'English US' }
];

export const tokens = state => state.tokens;
